// 백엔드개발팀 제공 API - Cloud Run
export const OSLO_BACKEND_API_DOMAIN = 'https://jmnet-oslo-api-75zws3ssea-du.a.run.app';
export const OSLO_BACKEND_PARTNER_API_DOMAIN = 'https://jmnet-oslo-api-342350879456.asia-northeast3.run.app'; // Espresso

// 프론트엔드개발팀 API - Cloud Run
export const OSLO_FRONTEND_API_DOMAIN = 'https://asia-northeast3-the-article-summarization.cloudfunctions.net'

const VERTEXTAI_MODEL_NUMBER = '0.6'
const ARTICLE_MODEL_NUMBER = '0.5'
const GENAI_MODEL_NUMBER = '0.4'

export const API_URLS = {
    MODEL_VERTEXAI_PARM2_ENGLISH: '/api/vertexai/palm2-eng',
    MODEL_VERTEXAI_PARM3_MODEL_LIST: '/api/vertexai/palm3-model-list',
    MODEL_VERTEXAI_PARM3_COMMON: '/api/vertexai/palm3',
    MODEL_VERTEXAI_MNP: '/api/vertexai/mnp',
    MODEL_VERTEXAI_PROMPTTEST: '/api/vertexai/prompt-test',

    LOGIN: '/api/login',
    LOGOUT: '/api/logout',
    CHECK_AUTH: '/api/check-auth',
}

export const EXTERNAL_API_URLS = {
    VERTEXAI_MODEL_LIST: `${OSLO_BACKEND_API_DOMAIN}/VertexAI/${VERTEXTAI_MODEL_NUMBER}/MethodList`,
    VERTEXAI_TRANSLATE_KOR_TO_END: `${OSLO_FRONTEND_API_DOMAIN}/createAIImage`,
    VERTEXAI_GET_ARTICLE_CONTENT: `${OSLO_BACKEND_API_DOMAIN}/VertexAI/${ARTICLE_MODEL_NUMBER}/articleContent`,

    GENAI_AICONVERSION_MODEL_COMPARISON: `${OSLO_BACKEND_API_DOMAIN}/GenAI/${GENAI_MODEL_NUMBER}/aiconversion/geniAi_model_comparison`,
    GENAI_AICONVERSION_GET_PROMPT: `${OSLO_BACKEND_API_DOMAIN}/GenAI/${GENAI_MODEL_NUMBER}/aiconversion/prompt`,
    GENAI_AICONVERSION_MODEL_COMPARISON_WITH_PROMPT: `${OSLO_BACKEND_API_DOMAIN}/GenAI/${GENAI_MODEL_NUMBER}/aiconversion/geniAi_model_comparison_custom_prompt`,

    GENAI_ESPRESSO_CONTENT_SUMMARY: `${OSLO_BACKEND_PARTNER_API_DOMAIN}/GenAI/0.9/get_url_content_summary`,
    GENAI_ESPRESSO_CONTENT_COMPARISON: `${OSLO_BACKEND_PARTNER_API_DOMAIN}/GenAI/0.9/get_url_content_compare`,

    GENAI_ARTICLE_AI_TITLE: `${OSLO_BACKEND_API_DOMAIN}/VertexAI/${GENAI_MODEL_NUMBER}/ArticleAiTitle`,
    GENAI_SERIES_PAYWALL_SUMMARY: `${OSLO_BACKEND_API_DOMAIN}/VertexAI/content/${GENAI_MODEL_NUMBER}/seriesPaywallSummary`,
    GENAI_PAYWALL_SUMMARY: `${OSLO_BACKEND_API_DOMAIN}/VertexAI/content/${GENAI_MODEL_NUMBER}/paywallSummary`,
    GENAI_ARTICLE_AI_KEYWORD: `${OSLO_BACKEND_API_DOMAIN}/VertexAI/content/${GENAI_MODEL_NUMBER}/ArticleAiKeyword`,

    GENAI_PAYWALL_SUMMARY_WITH_PROMPT: `${OSLO_BACKEND_API_DOMAIN}/VertexAI/content/${GENAI_MODEL_NUMBER}/paywallSummary_prompt_test`,
}

